var map = {
	"./admin-page/admin-page.module": [
		"./src/app/pages/admin-page/admin-page.module.ts",
		"admin-page-admin-page-module"
	],
	"./agenda/agenda.module": [
		"./src/app/pages/agenda/agenda.module.ts",
		"agenda-agenda-module"
	],
	"./book/book.module": [
		"./src/app/pages/book/book.module.ts",
		"book-book-module"
	],
	"./broadcast/broadcast.module": [
		"./src/app/pages/broadcast/broadcast.module.ts",
		"broadcast-broadcast-module"
	],
	"./empty-page/empty-page.module": [
		"./src/app/pages/empty-page/empty-page.module.ts",
		"empty-page-empty-page-module"
	],
	"./error-page/error-page.module": [
		"./src/app/pages/error-page/error-page.module.ts",
		"error-page-error-page-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./resources/resources.module": [
		"./src/app/pages/resources/resources.module.ts",
		"resources-resources-module"
	],
	"./rooms/rooms.module": [
		"./src/app/pages/rooms/rooms.module.ts",
		"default~rooms-rooms-module~tiles-tiles-module",
		"rooms-rooms-module"
	],
	"./sponsors/sponsors.module": [
		"./src/app/pages/sponsors/sponsors.module.ts",
		"sponsors-sponsors-module"
	],
	"./tiles/tiles.module": [
		"./src/app/pages/tiles/tiles.module.ts",
		"default~rooms-rooms-module~tiles-tiles-module",
		"tiles-tiles-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;